<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<div [class.spinner]="loading"></div>

<div class="trip-detail-popup">
  <p>Work Order Details</p>
  <mat-divider></mat-divider>
  <div class="row d-flex justify-content-center">
    <div class="col-sm-4">
      <div class="head d-flex">Truck Category :</div>
      <div class="result">
        {{ WODetails[0]?.truckCategoryInfo[0].truck_category_name }}
      </div>
    </div>
    <div class="col-sm-4">
      <div class="head">Total Tons :</div>
      <div class="result">
        {{ WODetails[0]?.total_tons | number : "1.2-2" }}
      </div>
    </div>
    <div class="col-sm-4">
      <div class="head">Price Per Ton :</div>
      <div class="result">
        ₹ {{ WODetails[0]?.price_per_ton | number : "1.2-2" }}
      </div>
    </div>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-sm-4">
      <div class="head">Total Assigned Trips :</div>
      <div class="result">{{ WODetails[0]?.tripInfo.length }}</div>
    </div>
    <div class="col-sm-4">
      <div class="head">Date :</div>
      <div class="result">
        {{ WODetails[0]?.pickup_date | date : "dd-MM-yyyy" }}
      </div>
    </div>
    <div class="col-sm-4">
      <div class="head">Material :</div>
      <div class="result">{{ WODetails[0]?.material_type }}</div>
    </div>
  </div>

  <div class="places">
    <!-- Pickup -->
    <div class="place-row">
      <mat-icon>near_me</mat-icon>
      <div class="place-text">
        <h4>{{ WODetails[0]?.pickup_details.from_city_name }}</h4>
        {{ WODetails[0]?.from_complete_address }}
        <div class="result">
          Contact Details: {{ WODetails[0]?.pickup_name }} - {{ WODetails[0]?.pickup_contact }}
        </div>
      </div>
    </div>
    <!-- Stops -->
    <div class="place-row" *ngFor="let stop of WODetails[0]?.stops; let i = index">
      <mat-icon>stop_circle</mat-icon>
      <div class="place-text">
        <h4>Stop {{ i + 1 }}: {{ stop.city_name }}</h4>
        <div>{{ stop.complete_address }}</div>
        <div class="result">Contact Details: {{ stop?.stop_contact_name }} - {{ stop?.stop_contact_number }}</div>
      </div>
    </div>
    <!-- Dropoff -->
    <div class="place-row">
      <mat-icon>location_on</mat-icon>
      <div class="place-text">
        <h4>{{ WODetails[0]?.dropoff_details?.to_city_name }}</h4>
        <div>{{ WODetails[0]?.to_complete_address }}</div>
        <div class="result">Contact Details: {{ WODetails[0]?.dropoff_name }} - {{ WODetails[0]?.dropoff_contact }}</div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <div class="head">Pickup Details :</div>
      <div class="result">
        {{ WODetails[0]?.from_complete_address }}
        <!-- {{ WODetails[0]?.pickup_details?.from_area_name }},
        {{ WODetails[0]?.pickup_details?.from_city_name }} -
        {{ WODetails[0]?.pickup_details?.from_pincode }} -->
      </div>
    </div>
    <div class="col-sm-6">
      <div class="head">Drop Off Details :</div>
      <div class="result">
        {{ WODetails[0]?.to_complete_address }}
        <!-- {{ WODetails[0]?.dropoff_details?.to_area_name }},
        {{ WODetails[0]?.dropoff_details?.to_city_name }} -
        {{ WODetails[0]?.dropoff_details?.to_pincode }} -->
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <div class="head">Pickup Contact :</div>
      <div class="result">{{ WODetails[0]?.pickup_name }}</div>
    </div>
    <div class="col-sm-6">
      <div class="head">Pickup Contact Number :</div>
      <div class="result">{{ WODetails[0]?.pickup_contact }}</div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="head">Drop Off Contact :</div>
      <div class="result">{{ WODetails[0]?.dropoff_name }}</div>
    </div>
    <div class="col-sm-6">
      <div class="head">Drop Off Contact Number :</div>
      <div class="result">{{ WODetails[0]?.dropoff_contact }}</div>
    </div>
  </div>
  <p>List of Trips</p>
  <mat-divider></mat-divider>
  <div *ngFor="let trips of WODetails[0]?.tripInfo; let i = index">
    <div class="row d-flex justify-content-center">
      <div class="col-sm-1"></div>
      <div class="col-sm-3">
        <div class="head">Trip ID :</div>
        <div class="result">{{ trips.trip_id }}</div>
      </div>
      <div class="col-sm-4">
        <div class="head">Truck Category :</div>
        <div class="result">
          {{ WODetails[0]?.truckCategoryInfo[0]?.truck_category_name }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head">Loaded Weight :</div>
        <div class="result">
          {{ (trips.workOrderOtherDetails.loading_point || 0) | number : "1.2-2" }} Tons
        </div>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-sm-1" style="color: #f58634; font-size: 20px">
        {{ i + 1 }}
      </div>
      <div class="col-sm-3">
        <div class="head">Truck Owner Name :</div>
        <div class="result">{{ trips.truckowner_id.username }}</div>
      </div>
      <!-- <div class="col-sm-3">
        <div class="head">Driver Number :</div>
        <div class="result">{{ trips.driver_ref_id.mobile }}</div>
      </div> -->
      <div class="col-sm-4">
        <div class="head">Net Quantity (Loading Point) :</div>
        <div class="result">
          {{ (trips.workOrderOtherDetails.loading_point || 0) | number : "1.2-2" }} Tons
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head">Net Quantity (UnLoading Point) :</div>
        <div class="result">
          {{ (trips.workOrderOtherDetails.unloading_point || 0) | number : "1.2-2" }} Tons
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-1"></div>
      <div class="col-sm-3">
        <div class="head">Amount :</div>
        <div class="result">
          ₹
          <!-- {{
            (
              WODetails[0]?.price_per_ton *
                trips.workOrderOtherDetails.loading_point ||
              WODetails[0]?.price_per_ton *
                trips.workOrderOtherDetails.unloading_point
            ).toFixed(2)
          }} -->
          {{
            WODetails[0]?.pay_as_load_quantity === "unloaded_quantity"
              ? (
                  WODetails[0]?.price_per_ton *
                  (trips.workOrderOtherDetails?.unloading_point || 0)
                ).toFixed(2)
              : WODetails[0]?.pay_as_load_quantity === "loaded_quantity"
              ? (
                  WODetails[0]?.price_per_ton *
                  (trips.workOrderOtherDetails?.loading_point || 0)
                ).toFixed(2)
              : "0.00"
          }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="head">LR Number :</div>
        <div class="result">{{ trips.workOrderOtherDetails.lr_number }}</div>
      </div>
      <div class="col-sm-4">
        <div class="head">DDC No :</div>
        <div class="result">{{ trips.workOrderOtherDetails.ddc_no }}</div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-sm-1"></div>
      <div class="col-sm-3">
        <div class="head">Vehicle Number :</div>
        <div class="result">{{ trips.truck_id?.truck_number }}</div>
      </div>
      <div class="col-sm-3">
        <div class="head">Truck Owner Name :</div>
        <div class="result">{{ trips.truckowner_id.username }}</div>
      </div>
      <div class="col-sm-3">
        <div class="head">Owner Contact Number :</div>
        <div class="result">{{ trips.truckowner_id.mobile }}</div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-sm-1"></div>
      <div class="col-sm-10">
        <div class="head">Driver Known Languages :</div>
        <div class="result">{{ (trips.driver_ref_id?.known_lang?.length && trips.driver_ref_id.known_lang[0].trim() !== '') ? trips.driver_ref_id.known_lang.join(', ') : 'NA' }}
        </div>

      </div>
    </div>
    <hr />
  </div>

  <div *ngIf="isBidRankingLoaded && !isBidRankingForbidden" class="mt-4" style="background-color: #f8fafc; padding: 20px; border-radius: 12px; font-family: 'Inter', sans-serif;">
    <div class="row">
      <!-- Left Column: Stats and Table -->
      <div class="col-md-8">
        <div class="row mb-4">
          <div [ngClass]="hasBidVisibility ? 'col-sm-6' : 'col-12'">
            <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 16px; height: 100%; display: flex; align-items: center;">
              <div style="background: #dcfce7; width: 48px; height: 48px; border-radius: 24px; display: flex; align-items: center; justify-content: center; margin-right: 16px;">
                <i class="fa fa-inr" style="color: #16a34a; font-size: 20px;"></i>
              </div>
              <div>
                <small style="color: #64748b; font-size: 13px; font-weight: 500; display: block; margin-bottom: 4px;">Current Lowest Bid (L1)</small>
                <div class="d-flex align-items-center">
                  <h3 style="margin-bottom: 0; color: #16a34a; font-weight: 800; font-size: 24px; margin-right: 12px;">₹ {{ bidRankingData[0]?.bid_rate ? (bidRankingData[0]?.bid_rate | number : '1.0-0') : '--' }}</h3>
                </div>
                <small style="color: #64748b; font-size: 13px;" *ngIf="hasBidVisibility && bidRankingData[0]?.truckOwnerDetails?.length">By {{ bidRankingData[0]?.truckOwnerDetails[0]?.username }} <span style="color: #22c55e; margin-left: 8px;"><i class="fa fa-clock-o"></i> Just now</span></small>
              </div>
            </div>
          </div>
          <div class="col-sm-6" *ngIf="hasBidVisibility">
            <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 16px; height: 100%; display: flex; align-items: center;">
              <div style="background: #dbeafe; width: 48px; height: 48px; border-radius: 24px; display: flex; align-items: center; justify-content: center; margin-right: 16px;">
                <i class="fa fa-users" style="color: #3b82f6; font-size: 20px;"></i>
              </div>
              <div>
                <small style="color: #64748b; font-size: 13px; font-weight: 500; display: block; margin-bottom: 4px;">Total Participants</small>
                <div class="d-flex align-items-center">
                  <h3 style="margin-bottom: 0; color: #3b82f6; font-weight: 800; font-size: 24px; margin-right: 12px;">{{ bidRankingData.length }}</h3>
                </div>
                <small style="color: #64748b; font-size: 13px;">Transporters have placed bids</small>
              </div>
            </div>
          </div>
        </div>

        <!-- All Bids Table (Shown only when bid visibility is enabled) -->
        <div *ngIf="hasBidVisibility" style="background: white; border-radius: 12px; border: 1px solid #e2e8f0; overflow: hidden;">
          <div style="display: flex; border-bottom: 1px solid #e2e8f0; padding: 0 20px;">
            <div style="padding: 16px 0; color: #0f172a; font-weight: 600; border-bottom: 2px solid #2563eb; font-size: 15px;">All Bids ({{ bidRankingData.length }})</div>
          </div>
          <div class="table-responsive">
            <table class="table mb-0" style="font-size: 14px;">
              <thead style="background-color: #f8fafc; color: #475569; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">
                <tr>
                  <th style="padding: 16px 20px; font-weight: 600; border-bottom: 1px solid #e2e8f0;">#</th>
                  <th style="padding: 16px 20px; font-weight: 600; border-bottom: 1px solid #e2e8f0;">TRANSPORTER</th>
                  <th style="padding: 16px 20px; font-weight: 600; border-bottom: 1px solid #e2e8f0;">QUOTED PRICE (₹)</th>
                  <th style="padding: 16px 20px; font-weight: 600; border-bottom: 1px solid #e2e8f0;">BID TIME</th>
                  <th style="padding: 16px 20px; font-weight: 600; border-bottom: 1px solid #e2e8f0;">STATUS</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="bidRankingData.length === 0">
                  <td colspan="5" style="padding: 24px; text-align: center; color: #64748b;">No bids placed yet.</td>
                </tr>
                <tr *ngFor="let bid of bidRankingData; let i = index" style="border-bottom: 1px solid #e2e8f0;">
                  <td style="padding: 16px 20px; color: #64748b;">{{ i + 1 }}</td>
                  <td style="padding: 16px 20px; font-weight: 500; color: #0f172a;">{{ bid.truckOwnerDetails[0]?.username || '-' }}</td>
                  <td style="padding: 16px 20px; font-weight: 700; color: #0f172a; font-size: 15px;">{{ bid.bid_rate | number : '1.0-0' }}</td>
                  <td style="padding: 16px 20px; color: #64748b; font-size: 13px;">
                    <div>{{ bid.createdAt | date : 'dd MMM yyyy' }}</div>
                    <div>{{ bid.createdAt | date : 'HH:mm:ss' }}</div>
                  </td>
                  <td style="padding: 16px 20px;">
                    <span [ngStyle]="{'background-color': i === 0 ? '#16a34a' : '#94a3b8', 'color': 'white', 'padding': '4px 10px', 'border-radius': '6px', 'font-size': '12px', 'font-weight': '600'}">
                      L{{ i + 1 }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="padding: 16px; text-align: center; color: #94a3b8; font-size: 13px; font-weight: 500; border-top: 1px solid #e2e8f0; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px; background: #fafafa;">
              <i class="fa fa-refresh me-1"></i> Auto refreshes every 30 seconds
            </div>
          </div>
        </div>

        <!-- Bidding Status Note (Shown when bid visibility is disabled and bidding has not expired) -->
        <div *ngIf="!hasBidVisibility && !isTimerExpired" style="background: white; border-radius: 12px; border: 1px solid #e2e8f0; padding: 20px;">
          <div style="display: flex; align-items: flex-start; gap: 14px;">
            <div style="background: #f1f5f9; min-width: 38px; height: 38px; border-radius: 10px; display: flex; align-items: center; justify-content: center;">
              <i class="fa fa-shield" style="color: #64748b; font-size: 18px;"></i>
            </div>
            <div>
              <div style="font-weight: 700; color: #0f172a; font-size: 14px; margin-bottom: 4px;">Market Bidding In Progress</div>
              <div style="color: #64748b; font-size: 13px; line-height: 1.6;">
                Transporters are submitting bids for your requirement. You have visibility into the current lowest quoted price (L1) and can lock the price anytime before bidding closes.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column: Sidebar Actions -->
      <div class="col-md-4">
        <div style="display: flex; flex-direction: column; gap: 16px;">

          
          <!-- Revise Price Box -->
          <div style="background: white; border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);">
            <div style="display: flex; align-items: center; color: #475569; font-size: 14px; font-weight: 600; margin-bottom: 12px;">
              <div style="width: 16px; height: 10px; background: #2563eb; border-radius: 2px; margin-right: 8px; position: relative; overflow: hidden;">
                <div style="position: absolute; right: -4px; top: -2px; width: 10px; height: 14px; background: white; transform: rotate(15deg);"></div>
              </div>
              Your Quoted Price (Base Rate) <i class="fa fa-info-circle ms-1" style="color: #94a3b8;"></i>
            </div>
            
            <ng-container *ngIf="!isEditingPrice">
              <h1 style="font-weight: 800; color: #0f172a; margin-bottom: 16px; font-size: 32px; letter-spacing: -0.5px;">₹ {{ WODetails[0]?.price_per_ton | number : '1.0-0' }}</h1>
              <button 
                *ngIf="isBidRankingLoaded && ModelData?.work_order_status == 'present_work_order' && (!bidRankingData || bidRankingData.length === 0) && !isTimerExpired"
                style="width: 100%; background: #e11d48; color: white; border: none; border-radius: 8px; padding: 12px; font-weight: 600; font-size: 15px; display: flex; align-items: center; justify-content: center; gap: 8px; transition: background 0.2s;"
                onmouseover="this.style.background='#be123c'" onmouseout="this.style.background='#e11d48'"
                (click)="toggleEditPrice()">
                <i class="fa fa-edit"></i> Revise Price
              </button>
            </ng-container>

            <ng-container *ngIf="isEditingPrice">
              <div class="input-group mb-3">
                <span class="input-group-text" style="background: white; border-right: none; font-weight: 600;">₹</span>
                <input type="number" class="form-control price-edit-input" [(ngModel)]="newPriceValue" style="border-left: none; font-weight: 700; font-size: 20px; color: #0f172a; padding-left: 0;">
              </div>
              <div style="display: flex; gap: 8px;">
                <button 
                  style="flex: 1; background: #f1f5f9; color: #475569; border: none; border-radius: 8px; padding: 10px; font-weight: 600;"
                  (click)="toggleEditPrice()" [disabled]="isUpdatingPrice">
                  Cancel
                </button>
                <button 
                  style="flex: 1; background: #2563eb; color: white; border: none; border-radius: 8px; padding: 10px; font-weight: 600;"
                  (click)="submitNewPrice()" [disabled]="isUpdatingPrice">
                  <i class="fa fa-spinner fa-spin" *ngIf="isUpdatingPrice"></i> Save
                </button>
              </div>
            </ng-container>

            <p *ngIf="isBidRankingLoaded && ModelData?.work_order_status == 'present_work_order' && (!bidRankingData || bidRankingData.length === 0) && !isTimerExpired && !isEditingPrice" style="font-size: 12px; color: #94a3b8; text-align: center; margin-top: 12px; line-height: 1.5; margin-bottom: 0;">
              You can revise your quoted price only if no transporter has placed a bid.
            </p>
          </div>

          <!-- Timer Box -->
          <div *ngIf="ModelData?.work_order_status == 'present_work_order'" style="background: white; border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px; display: flex; align-items: center; gap: 16px; box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);">
            <div style="background: #fee2e2; width: 48px; height: 48px; border-radius: 24px; display: flex; align-items: center; justify-content: center;">
              <i class="fa fa-clock-o" style="color: #ef4444; font-size: 24px;"></i>
            </div>
            <div>
              <div style="color: #94a3b8; font-weight: 600; font-size: 13px; margin-bottom: 2px;">{{ isTimerExpired ? 'Bidding expired' : 'Bidding ends in' }}</div>
              <div style="color: #ef4444; font-weight: 800; font-size: 28px; letter-spacing: 2px; line-height: 1;">
                {{ timerHours }}<span style="color:#f87171">:</span>{{ timerMinutes }}<span style="color:#f87171">:</span>{{ timerSeconds }}
              </div>
              <div style="display: flex; gap: 14px; color: #cbd5e1; font-size: 11px; margin-top: 4px; padding-left: 2px;">
                <span>Hours</span><span>Minutes</span><span>Seconds</span>
              </div>
            </div>
          </div>


          <!-- Lock Price Button -->
          <button 
            *ngIf="bidRankingData && bidRankingData.length > 0 && !isTimerExpired"
            style="background: #16a34a; color: white; border: none; border-radius: 12px; padding: 20px; display: flex; align-items: center; justify-content: flex-start; gap: 16px; width: 100%; transition: background 0.2s; box-shadow: 0 4px 6px -1px rgba(22, 163, 74, 0.4);"
            onmouseover="this.style.background='#15803d'" onmouseout="this.style.background='#16a34a'"
            (click)="openConfirmModal()">
            <div style="background: rgba(255,255,255,0.2); min-width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center;">
              <i class="fa fa-lock" style="font-size: 20px;"></i>
            </div>
            <div style="text-align: left;">
              <div style="font-weight: 700; font-size: 16px; margin-bottom: 4px;">Lock Price & Confirm Bid</div>
              <div style="opacity: 0.9; font-size: 13px; font-weight: 500;">Book now at ₹ {{ bidRankingData[0]?.bid_rate | number : '1.0-0' }}</div>
            </div>
          </button>
          

          <!-- Need Assistance Box -->
          <div style="background: white; border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px;">
            <div style="display: flex; align-items: flex-start; gap: 12px; margin-bottom: 16px;">
              <div style="background: #eff6ff; min-width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center;">
                <i class="fa fa-comment-o" style="color: #3b82f6; font-size: 16px;"></i>
              </div>
              <div>
                <div style="color: #0f172a; font-weight: 700; font-size: 14px; margin-bottom: 2px;">Need assistance?</div>
                <div style="color: #64748b; font-size: 12px; line-height: 1.4;">Contact our support team for any help.</div>
              </div>
            </div>
            <div style="display: flex; gap: 10px;">
              <a href="tel:+919059282736" style="flex: 1; background: white; border: 1px solid #e2e8f0; border-radius: 8px; padding: 12px 4px; color: #475569; font-weight: 600; font-size: 13px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; text-decoration: none; transition: all 0.2s;">
                <i class="fa fa-phone" style="color: #3b82f6; font-size: 18px;"></i>
                <span style="white-space: nowrap;">+91-90592 82736</span>
              </a>
              <a href="mailto:contact@s9trucks.com" style="flex: 1; background: white; border: 1px solid #e2e8f0; border-radius: 8px; padding: 12px 4px; color: #475569; font-weight: 600; font-size: 13px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; text-decoration: none; transition: all 0.2s;">
                <i class="fa fa-envelope" style="color: #64748b; font-size: 18px;"></i>
                <span style="white-space: nowrap; font-size: 11px;">contact@s9trucks.com</span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="row ml-0 mr-0 mt-4">
    <div class="d-flex justify-content-around">
      <button type="button" class="button buttonBlue" (click)="help()">
        Help
      </button>
    </div>
  </div>
</div>

<!-- Confirm Trip Modal -->
<div *ngIf="showConfirmTripModal" style="position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1050; padding: 16px;">
  <div style="background: white; border-radius: 16px; width: 100%; max-width: 400px; padding: 24px; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); position: relative;">
    
    <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 20px;">
      <div style="background: #ecfdf5; min-width: 40px; height: 40px; border-radius: 12px; display: flex; align-items: center; justify-content: center;">
        <i class="fa fa-lock" style="color: #059669; font-size: 18px;"></i>
      </div>
      <h3 style="margin: 0; font-size: 20px; font-weight: 700; color: #0f172a;">Confirm Bid</h3>
    </div>

    <div style="background: #ecfdf5; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px; display: flex; align-items: center; gap: 10px; color: #059669; font-weight: 600;">
      <i class="fa fa-line-chart" style="transform: scaleY(-1);"></i>
      Lowest Bid (L1): ₹ {{ bidRankingData[0]?.bid_rate | number : '1.0-0' }}
    </div>

    <div style="color: #475569; font-size: 14px; line-height: 1.6; margin-bottom: 16px;">
      Booking starts with the L1 (lowest) transporter. Each transporter gets a limited time window to add their trucks, and the quantity they cover is defined by the trucks they actually add.
    </div>
    
    <div style="color: #475569; font-size: 14px; line-height: 1.6; margin-bottom: 16px;">
      If L1 cannot cover your full requirement of {{ WODetails[0]?.workorder_qty }} {{ WODetails[0]?.unit }}, the remaining quantity automatically moves to the next bidder (L2), then L3, and so on each within their own time window - until your load is fully assigned.
    </div>

    <div style="background: #f8fafc; border-radius: 8px; padding: 16px; margin-bottom: 24px; border: 1px solid #e2e8f0;">
      <div style="color: #0284c7; font-weight: 600; font-size: 13px; margin-bottom: 8px; display: flex; align-items: center; gap: 6px;">
        <i class="fa fa-lightbulb-o"></i> Example
      </div>
      <div style="color: #475569; font-size: 13px; line-height: 1.5;">
        Your requirement is 100 MT. L1 adds 2 trucks of 20 MT = 40 MT covered. The remaining 60 MT moves to L2 to add their trucks, and so on until the full 100 MT is assigned.
      </div>
    </div>

    <div style="display: flex; gap: 12px;">
      <button style="flex: 1; background: white; color: #64748b; border: 1px solid #cbd5e1; border-radius: 8px; padding: 12px; font-weight: 600; font-size: 15px; transition: all 0.2s;" onmouseover="this.style.background='#f1f5f9'" onmouseout="this.style.background='white'" (click)="closeConfirmModal()">Cancel</button>
      <button style="flex: 1; background: #16a34a; color: white; border: none; border-radius: 8px; padding: 12px; font-weight: 600; font-size: 15px; transition: background 0.2s;" onmouseover="this.style.background='#15803d'" onmouseout="this.style.background='#16a34a'" (click)="closeBidding(); closeConfirmModal()">Confirm</button>
    </div>
  </div>
</div>
